<template>
  <el-form ref="form" :model="form" label-width="150px" class="elForm">
    <el-form-item label="会员年费：">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 300px">
        <template slot="append">元</template>
      </el-input>
    </el-form-item>
    <el-form-item label="会员送优惠券福利：">
      <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      <br />
      <ul>
        <li v-for="(item, index) in serviceAreaList" :key="index">
          <div>
            <label for="" style="margin-right: 20px">赠送优惠券</label>
            <el-select v-model="form.region" placeholder="">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </div>
          <div>
            <label for="" style="margin-right: 20px">数量</label>
            <el-input placeholder="请输入数量" v-model="input2" style="width: 300px">
              <template slot="append">元</template>
            </el-input>
          </div>
          <el-link v-if="index >= 1" type="primary" @click="delService(item.id)">删除</el-link>
        </li>
      </ul>
      <el-link style="color: blue" @click="addService">+添加优惠券</el-link>
    </el-form-item>
    <el-form-item label="有效期：">
      领卡激活时起
      <el-input v-model="form.name" placeholder="数值" style="width: 300px; margin: 0 10px"></el-input>
      天内有效
    </el-form-item>
    <el-form-item label="会员等级设置：">
      <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949" style="margin-right: 20px"></el-switch>
      <span>注意：下面每添加一个等级，积分都要比上一条数据的积分高，要求会员积分不要出现重叠或者间隔</span>
      <br />
      <ul>
        <li v-for="(item, index) in VIPList" :key="index">
          <div>
            <label for="" style="margin-right: 20px">会员等级名称</label>
            <el-input placeholder="请输入会员等级名称" v-model="input2" style="width: 300px"></el-input>
          </div>
          <div>
            <label for="" style="margin-right: 20px">要求会员积分>=</label>
            <el-input placeholder="积分" v-model="input2" style="width: 300px">
              <template slot="append">积分</template>
            </el-input>
          </div>
          <el-link v-if="index >= 1" type="primary" @click="delVIP(item.id)">删除</el-link>
        </li>
      </ul>
      <el-link style="color: blue" @click="addVIP">+添加会员等级</el-link>
    </el-form-item>
    <el-form-item label="会员权益：">
      <RichText :richTxt="form.goods_details" @soninfo="val => (form.goods_details = val)"></RichText>
    </el-form-item>
    <el-form-item class="centerBtn">
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import RichText from '@/components/richText';
export default {
  components: {
    RichText,
  },
  data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      // 优惠券
      serviceAreaList: [
        {
          id: 1,
          name: 'hh',
        },
      ],
      // 会员等级
      VIPList: [
        {
          id: 1,
          name: 'hh',
        },
      ],
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },

    // 添加优惠券
    addService() {
      this.serviceAreaList.push({
        id: this.serviceAreaList.length + 1,
        name: 'jj',
      });
      console.log(this.serviceAreaList);
    },

    // 删除优惠券
    delService(id) {
      let index = this.serviceAreaList.findIndex(item => item.id == id);
      console.log(index);
      this.serviceAreaList.splice(index, 1);
    },

    // 添加会员等级
    addVIP() {
      this.VIPList.push({
        id: this.VIPList.length + 1,
        name: 'jj',
      });
      console.log(this.VIPList);
    },

    // 删除会员等级
    delVIP(id) {
      let index = this.VIPList.findIndex(item => item.id == id);
      console.log(index);
      this.VIPList.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.elForm {
  background-color: #fff;
  padding: 30px;
}

.centerBtn {
  display: flex;
  justify-content: center;
  align-items: center;
}

ul li {
  display: flex;

  div {
    margin: 10px 10px 0 0;
  }
}
</style>
